import React from 'react';

import NumberFormatInput from '../NumberFormatInput';
import FormikField, { FormikFieldProps } from './FormikField';

const FormikNumberFormatInputField = (props: FormikFieldProps) => {
  const { field, form, showNoError, formHelperTextClassName, ...other } = props;

  return (
    <FormikField field={field} form={form} showNoError={showNoError} formHelperTextClassName={formHelperTextClassName}>
      <NumberFormatInput
        onChange={({ target }) => {
          form.setFieldValue(field.name, target.value, true);
          form.setTouched({ [field.name]: true });
        }}
        // $FlowFixMe
        {...other}
        error={!!form.touched[field.name] && !!form.errors[field.name]}
      />
    </FormikField>
  );
};

export default FormikNumberFormatInputField;
